export default "__VITE_ASSET__BTisHjTO__"